// extracted by mini-css-extract-plugin
module.exports = {"modal":"ServiceProviderChangeModal_modal__lokJp","button":"ServiceProviderChangeModal_button___653y","buttons":"ServiceProviderChangeModal_buttons___1yxB"};